// extracted by mini-css-extract-plugin
module.exports = {"vanlife-C":"C_vanlife-C__0vHJg"};